<template>
  <a-button
    :html-type="htmlType"
    :class="[
      'btn',
      { 'btn-normal': typeBtn === 'normal' },
      { 'btn-primary': typeBtn === 'primary' },
      { 'btn-primary--2': typeBtn === 'primary-2' },
      classes ? classes : '',
    ]"
    :disabled="typeBtn === 'disable' ? true : false"
    @click="onClick"
  >
    <span>{{ text }}</span>
    <img
      src="@/assets/images/arrow-right-white.svg"
      alt="arrow-right"
      class="btn-icon"
      v-if="showIcon && typeBtn !== 'primary'"
    />
    <img
      src="@/assets/images/arrow-right-blue.svg"
      alt="arrow-right"
      class="btn-icon"
      v-if="showIcon && typeBtn === 'normal'"
    />
  </a-button>
</template>

<script>
export default {
  props: {
    typeBtn: { type: String, required: true },
    text: { type: String, required: true },
    htmlType: String,
    showIcon: Boolean,
    classes: String,
    onClick: Function
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/common.scss";
.btn {
  &-icon {
    width: 6px;
    margin-left: 12px;
  }
}
.btn.btn-primary {
  @include btn(#04a4de, #ffffff, #04a4de);
  &:hover {
    background: rgba($color: #04a4de, $alpha: 1);
    color: #ffffff;
  }
}

.btn.btn[disabled] {
  @include btn(#cfcfcf80, #9f9f9f, #cfcfcf80);
  &:hover {
    background: #cfcfcf80;
    color: #9f9f9f;
    border-color: #cfcfcf80;
  }
}

.btn.btn-primary--2 {
  @include btn(#1fbaf21a, #04a4de, #1fbaf21a);
}

.btn.btn-normal {
  @include btn(#ffffff, #04a4de, #04a4de);
}
</style>
